(function () {
  if (window.__pkCardSliderInit) return;
  window.__pkCardSliderInit = true;

  function initSlider(root) {
    if (!root || root.dataset.pkReady === '1') return;
    root.dataset.pkReady = '1';

    var track = root.querySelector('[data-pk-track]');
    var prev  = root.querySelector('[data-pk-prev]');
    var next  = root.querySelector('[data-pk-next]');
    var dots  = root.querySelectorAll('[data-pk-dot]');
    var count = parseInt(root.dataset.count, 10) || 1;
    var i = 0;

    if (!track || count < 2) return;

    function go(n) {
      i = (n + count) % count;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
    }

    function stop(e){
      e.preventDefault();
      e.stopPropagation();
    }

    if (prev) prev.addEventListener('click', function(e){ stop(e); go(i - 1); });
    if (next) next.addEventListener('click', function(e){ stop(e); go(i + 1); });

    // Arrows pe pointerdown bhi rok do — Embla ka drag start na ho
    [prev, next].forEach(function(btn){
      if (!btn) return;
      btn.addEventListener('pointerdown', function(e){ e.stopPropagation(); });
      btn.addEventListener('mousedown',  function(e){ e.stopPropagation(); });
      btn.addEventListener('touchstart', function(e){ e.stopPropagation(); }, { passive:true });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pk-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ boot(); });
  } else {
    boot();
  }

  // Shopify section reload / theme editor
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  document.addEventListener('shopify:section:reorder', function(e){ boot(e.target); });

  // AJAX se aane wali cards (filters, infinite scroll, quick view etc.)
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(node){
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-pk-slider]')) initSlider(node);
          if (node.querySelectorAll) boot(node);
        });
      });
    }).observe(document.body, { childList:true, subtree:true });
  }
})();